import { NavLink } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Home, LayoutGrid, Tag, User as UserIcon } from "lucide-react";

export default function BottomTabBar() {
  const { user } = useAuth();
  if (!user || user === false) return null;

  const item = ({ isActive }) =>
    `flex flex-col items-center gap-1 flex-1 py-2 ${isActive ? "text-brand-teal" : "text-brand-muted hover:text-brand-ink"} transition-colors`;

  return (
    <nav
      data-testid="bottom-tab-bar"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/85 backdrop-blur-xl border-t border-brand-border/60 pb-safe"
    >
      <div className="flex items-stretch h-16 px-2">
        <NavLink to="/" end className={item} data-testid="tab-home">
          <Home size={20} strokeWidth={2} />
          <span className="text-[10px] font-medium">Home</span>
        </NavLink>
        <NavLink to="/projects" className={item} data-testid="tab-projects">
          <LayoutGrid size={20} strokeWidth={2} />
          <span className="text-[10px] font-medium">Projects</span>
        </NavLink>
        <NavLink to="/pricing" className={item} data-testid="tab-pricing">
          <Tag size={20} strokeWidth={2} />
          <span className="text-[10px] font-medium">Pricing</span>
        </NavLink>
        <NavLink to="/account" className={item} data-testid="tab-account">
          <UserIcon size={20} strokeWidth={2} />
          <span className="text-[10px] font-medium">Account</span>
        </NavLink>
      </div>
    </nav>
  );
}
